import { TicketCategory1 } from '@work4all/models/lib/Classes/TicketCategory1.entity';
import { TicketKind } from '@work4all/models/lib/Classes/TicketKind.entity';
import { Topic } from '@work4all/models/lib/Classes/Topic.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { MaskControllerProps } from '../../types';
import { GeneralSettingsOverlayController } from '../general-settings/GeneralSettingsOverlayController';

import { ExtendedGeneralSettingsEntity } from './types';

export const TicketCategory1OverlayController = (
  props: MaskControllerProps
) => {
  return (
    <GeneralSettingsOverlayController<
      TicketCategory1 & ExtendedGeneralSettingsEntity
    >
      {...props}
      entity={Entities.ticketCategory1}
    />
  );
};

export const TicketKindOverlayController = (props: MaskControllerProps) => {
  return (
    <GeneralSettingsOverlayController<
      TicketKind & ExtendedGeneralSettingsEntity
    >
      {...props}
      entity={Entities.ticketKind}
    />
  );
};

export const TopicOverlayController = (props: MaskControllerProps) => {
  return (
    <GeneralSettingsOverlayController<Topic & ExtendedGeneralSettingsEntity>
      {...props}
      entity={Entities.topic}
      skip={true}
    />
  );
};
